import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { JSONRpc } from './service-jsonrpc';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class AppService {
  cacheListStatusDossier: any[];
  cacheListStateDossier: any[];
  cacheListZoneDossier: any[];

  constructor(
    private http: HttpClient
  ) {}

  callPOSTJSONRpc(url, rpcMethod): Observable<any> {
    return this.http.post<JSONRpc>(url + '?' + rpcMethod.method, rpcMethod);
  }

  getEnv(): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc : "2.0",
      method:"webservice.connection:getEnv",
      params: {}
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);

  }
  getConnectToken(): Observable<any> {
      let rpcMethod = new JSONRpc({
        jsonrpc : "2.0",
        method:"webservice.connection:getToken"
      });
      return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }

  getTokenCalcForDelegation(): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc : "2.0",
      method:"webservice.connection:getTokenCalcForDelegation"
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }

  login(login, password): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc : "2.0",
      method:"webservice.connection:connect",
      params: {
        email: login,
        password: password
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);

  }
  
  refreshUser(): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc : "2.0",
      method:"webservice.connection:user",
      params: {}
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }

  logout(){
    let rpcMethod = new JSONRpc({
      jsonrpc : "2.0",
      method:"webservice.connection:logout",
      params: {
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }

  connectAfterConfirm(login, id): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc : "2.0",
      method:"webservice.connection:connectAfterConfirm",
      params: {
        email: login,
        id: id
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);

  }
  getUserByToken(token): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc : "2.0",
      method:"webservice.connection:isconnected",
      params: {
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }

  register(entreprise, civilite, firstname, name, email, password, telephone): Observable<any> {

    let rpcMethod = new JSONRpc({
        jsonrpc : "2.0",
        method:"webservice.connection:register",
        params: {
            entreprise: entreprise,
            civilite: civilite,
            firstname: firstname,
            name: name,
            email: email,
            password: password,
            telephone: telephone
        }
      });
      return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }

  updateUser(id, entreprise, civilite, firstname, name, email, password, options = {}): Observable<any> {

    let rpcMethod = new JSONRpc({
      jsonrpc : "2.0",
      method:"webservice.connection:updateuser",
      params: {
          id: id,
          entreprise: entreprise,
          civilite: civilite,
          firstname: firstname,
          name: name,
          email: email,
          password: password,
          options: options
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }

  registerEssaiGratuit(entreprise, civilite, firstname, name, email, password, telephone, source, campagne): Observable<any> {
    let rpcMethod = new JSONRpc({
        jsonrpc : "2.0",
        method:"webservice.connection:registerEssaiGratuit",
        params: {
            entreprise: entreprise,
            civilite: civilite,
            firstname: firstname,
            name: name,
            email: email,
            password: password,
            telephone: telephone,
            source: source,
            campagne: campagne
        }
      });
      return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }

  updatePassword(id, password): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc : "2.0",
      method:"webservice.connection:updatepassword",
      params: {
          id: id,
          password: password,
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }

  saveAdresse(id, adresse): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc : "2.0",
      method:"webservice.connection:saveadresse",
      params: {
          id: id,
          adresse: adresse,
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }

  verificationMail(email): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc : "2.0",
      method:"webservice.connection:verificationmail",
      params: {
          email: email
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }

  getDossiersById(idUser, filters): Observable<any> {
    let rpcMethod = new JSONRpc({
        jsonrpc : "2.0",
        method:"webservice.dossier:getByUserId",
        params: {
            id: idUser,
            options : filters
        }
      });
      return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }

  getDossierById(iddossier, filters = []): Observable<any> {
    let rpcMethod = new JSONRpc({
        jsonrpc : "2.0",
        method:"webservice.dossier:getByDossierId",
        params: {
            id: iddossier,
            options : filters
        }
      });
      return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }

  addDossier(civilite, siret, firstname, name, entreprise, poste, datecontrat, datedebperiode, datesortiecontrat,
             typecontrat, statutsalaire, motifsortie, /*suspendu, suspPeriode,*/ maladie, dateMaladie, 
             datefinperiode, contRompu, dateRupt, nomDateRupt, boolRupt, couponId,
             pseudoSalarie, pseudoEntreprise, isAnonyme
             ): Observable<any> {
    console.log("couponId", couponId)
              let rpcMethod = new JSONRpc({
        jsonrpc : "2.0",
        method:"webservice.dossier:new",
        params: {
            civilite: civilite,
            siret: siret,
            firstname: firstname,
            name: name,
            entreprise: entreprise,
            poste: poste,
            datecontrat: datecontrat,
            datedebperiode: datedebperiode,
            datesortie: datesortiecontrat,
            typecontrat: typecontrat,
            statutsalarie: statutsalaire,
            motifsortie: motifsortie,
            //suspendu: suspendu,
            //suspPeriode: suspPeriode,
            maladie: maladie,
            dateMaladie: dateMaladie,
            datefinperiode: datefinperiode,
            contRompu: contRompu,
            dateRupt: dateRupt,
            nomDateRupt: nomDateRupt,
            boolRupt: boolRupt,
            pseudoEntreprise: pseudoEntreprise,
            pseudoSalarie: pseudoSalarie,
            isAnonyme: isAnonyme,
            couponId:couponId,
        }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }

  updateDossier(
      dossierId: string,
      civilite: string,
      siret: string,
      firstname: string,
      name: string,
      entreprise: string,
      poste: string,
      datecontrat: string,
      datedebperiode: string, // Obligatoire
      datesortie: string | null,
      typecontrat: string,
      statutsalarie: string,
      motifsortie: string,
      pseudoSalarie: string,
      pseudoEntreprise: string,
      isAnonyme: boolean,
      options: any = {}
  ): Observable<any> {
      let rpcMethod = new JSONRpc({
          jsonrpc: "2.0",
          method: "webservice.dossier:update",
          params: {
              dossierId: dossierId,
              civilite: civilite,
              siret: siret,
              firstname: firstname,
              name: name,
              entreprise: entreprise,
              poste: poste,
              datecontrat: datecontrat,
              datedebperiode: datedebperiode, // Obligatoire
              datesortie: datesortie,
              typecontrat: typecontrat,
              statutsalarie: statutsalarie,
              motifsortie: motifsortie,
              pseudoSalarie: pseudoSalarie,
              pseudoEntreprise: pseudoEntreprise,
              isAnonyme: isAnonyme,
              options: options,
          }
      });
      return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }



  addBasicDossier(): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc : "2.0",
      method:"webservice.dossier:newBasic",
      params: {
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }

  // updateDossierLight(id, data): Observable<any> {
  //     let rpcMethod = new JSONRpc({
  //       jsonrpc : "2.0",
  //       method:"webservice.dossier:updatelight",
  //       params: {
  //           id: id,
  //           data: data
  //       }
  //   });
  //   return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  // }

  updateDossierDelegation(id, civilite, firstname, name, entreprise, poste, datecontrat, datedebperiode, datesortiecontrat,
    typecontrat, statutsalaire, motifsortie, /*suspendu, suspPeriode,*/ maladie, dateMaladie, datefinperiode, contRompu, dateRupt, nomDateRupt, boolRupt,
    siret, pseudoSalarie, pseudoEntreprise, isAnonyme): Observable<any> {
      let rpcMethod = new JSONRpc({
        jsonrpc : "2.0",
        method:"webservice.dossier:updateFromDelegation",
        params: {
            id: id,
            civilite: civilite,
            firstname: firstname,
            name: name,
            entreprise: entreprise,
            poste: poste,
            datecontrat: datecontrat,
            datedebperiode: datedebperiode,
            datesortie: datesortiecontrat,
            typecontrat: typecontrat,
            statutsalarie: statutsalaire,
            motifsortie: motifsortie,
            //suspendu: suspendu,
            //suspPeriode: suspPeriode,
            maladie: maladie,
            dateMaladie: dateMaladie,
            datefinperiode: datefinperiode,
            contRompu: contRompu,
            dateRupt: dateRupt,
            nomDateRupt: nomDateRupt,
            boolRupt: boolRupt,
            siret: siret,
            pseudoEntreprise: pseudoEntreprise,
            pseudoSalarie: pseudoSalarie,
            isAnonyme: isAnonyme,
        }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }
  getMissingBS(dossier:any, calcPeriode = false): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc: "2.0",
      method: "webservice.dossier:getMissingBS",
      params: {
        dossier: dossier,
        calcPeriode: calcPeriode
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }
  checkValidationDossier(dossier: any, bsSecondaireAlone = true): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc: "2.0",
      method: "webservice.dossier:checkValidationDossier",
      params: {
        dossier: dossier,
        bsSecondaireAlone:bsSecondaireAlone
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }
  changeEtatDossier(iddossier: any, etat: any): Observable<any> {

    let rpcMethod = new JSONRpc({
      jsonrpc: "2.0",
      method: "webservice.dossier:changeEtat",
      params: {
        id: iddossier,
        etat: etat
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }
  changeEtatValidationDossier(iddossier: any, etat: any): Observable<any> {

    let rpcMethod = new JSONRpc({
      jsonrpc: "2.0",
      method: "webservice.dossier:changeEtatDossier",
      params: {
        id: iddossier,
        etat: etat
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }
  archiveDossier(iddossier:any): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc: "2.0",
      method: "webservice.dossier:archiveDossier",
      params: {
        id: iddossier
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }
  deleteDossier(iddossier:any): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc: "2.0",
      method: "webservice.dossier:deleteDossier",
      params: {
        id: iddossier
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }
  uploadDocument(file: File, dossierId: string, testAnonymize: string = ""): Observable<any> {
    let testData:FormData = new FormData();
    testData.append('file_upload', file, file.name);
    testData.append('dossierId', dossierId);
    testData.append('testAnonymize', testAnonymize);
    return this.http.post(environment.webservice+"upload", testData);
  }
  downloadDocument(fileurl:string, name:string): Observable<any> {
    let testData:FormData = new FormData();
    testData.append('fileurl', fileurl);
    testData.append('name', name);
    return this.http.post(environment.webservice+"downloadBS", testData,{responseType: 'blob'});
  }
  getUrlDownload(fileurl:string): Observable<any> {
    let testData:FormData = new FormData();
    testData.append('fileurl', fileurl);
    return this.http.post(environment.webservice+"getUrlDownload", testData);
  }

  getDocumentLink(fileurl: string, name: string, isCrypted = null) {
    let formData: FormData = new FormData();
    formData.append('fileurl', fileurl);
    formData.append('name', name);
    formData.append('isCrypted', isCrypted);
    return this.http.post(environment.webservice+"documentLink", formData, {responseType: 'blob'});
  } 

  removeBulletin(listids: any, deleteBsSecondaire:boolean){
    let rpcMethod = new JSONRpc({
      jsonrpc : "2.0",
      method:"webservice.bulletin:removeBulletin",
      params: {
          ids: listids,
          deleteBsSecondaire : deleteBsSecondaire
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }

  saveCalculData(iddossier, data: any): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc: "2.0",
      method: "webservice.dossier:saveCalculData",
      params: {
        id: iddossier,
        data: data
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }

  getDossierEntete(iddossier): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc: "2.0",
      method: "webservice.dossier:getDossierEntete",
      params: {
        id: iddossier,
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  } 
  getDossierRapport(iddossier): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc: "2.0",
      method: "webservice.dossier:getDossierRapport",
      params: {
        id: iddossier,
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }

  addDossierEntete(iddossier,data): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc: "2.0",
      method: "webservice.dossier:addDossierEntete",
      params: {
        iddossier: iddossier,
        data: data
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }



  rapport(iddossier, calcul, return_all_rapport = true): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc: "2.0",
      method: "webservice.dossier:rapport",
      params: {
        iddossier: iddossier,
        calcul: calcul,
        return_all_rapport: return_all_rapport,
        token_calc: environment.tokencalc
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }

    createMultipleRapports(idDossier): Observable<any> {
        let rpcMethod = new JSONRpc({
            jsonrpc: "2.0",
            method: "webservice.dossier:createMultipleRapports",
            params: {
                idDossier: idDossier,
                token_calc: environment.tokencalc
            }
        });
        return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
    }

    getCourrierHtml(dossierId, courrierName): Observable<any> {
        let rpcMethod = new JSONRpc({
          jsonrpc: "2.0",
          method: "webservice.courrier:getCourrierHtml",
          params: {
            dossierId: dossierId,
            courrierName: courrierName
          }
        });
        return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
    }

    createMultipleCourriers(idDossier, courriersNames): Observable<any> {
        let rpcMethod = new JSONRpc({
            jsonrpc: "2.0",
            method: "webservice.courrier:createMultipleCourriers",
            params: {
                dossierId: idDossier,
                courriersNames: courriersNames,
                token_calc: environment.tokencalc
            }
        });
        return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
    }

    downloadCourrier(dossierId, courrierName, type): Observable<any> {
        let courrierData : FormData = new FormData();
        courrierData.append('dossierId', dossierId);
        courrierData.append('courrierName', courrierName);
        courrierData.append('type', type);
        courrierData.append('tokencalc', environment.tokencalc);
        return this.http.post(
          environment.webservice + "downloadCourrier", courrierData , {responseType: 'blob'} );
    }

    getCourriers(dossierId): Observable<any> {
      let rpcMethod = new JSONRpc({
        jsonrpc: "2.0",
        method: "webservice.courrier:getCourriers",
        params: {
          dossierId: dossierId,
        }
      });
      return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
    }

  downloadrapport(iddossier, calcul, type): Observable<any> {
    
    let testData:FormData = new FormData();
    testData.append('iddossier', iddossier);
    testData.append('calcul', calcul);
    testData.append('type', type);
    testData.append('tokencalc', environment.tokencalc); // #2162 envoi du token pour le bocc
    return this.http.post(environment.webservice+"downloadRapport",testData ,{responseType: 'blob'});
  }

  downloadComparaison(dossiers, type): Observable<any> 
  {
    let formData = new FormData();
    formData.append('dossiers', dossiers);
    formData.append('type', type);
    formData.append('tokencalc', environment.tokencalc);
    return this.http.post(environment.webservice+"downloadComparaison", formData , {responseType: 'blob'});
  }

  consolidationBS(iddossier): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc: "2.0",
      method: "webservice.dossier:consolidBS",
      params: {
        iddossier: iddossier,
        token_calc: environment.tokencalc
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }

  processPauseCobham(iddossier): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc: "2.0",
      method: "webservice.dossier:processPauseCobham",
      params: {
        iddossier: iddossier,
        token_calc: environment.tokencalc
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }

  duplicateDossier(iddossier): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc: "2.0",
      method: "webservice.dossier:duplicateDossier",
      params: {
        iddossier: iddossier,
        fromFront: true,
        fromBack: false,
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }
  duplicateBS(allBS,iddossier): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc: "2.0",
      method: "webservice.dossier:duplicateBS",
      params: {
        bs: allBS,
        iddossier : iddossier
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }


  forgetpass(login:string): Observable<any> {
    let testData:FormData = new FormData();
    testData.append('email', login);
    return this.http.post(environment.webservice+"password", testData);
  }

  modifyPassword(login:string, password:string): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc: "2.0",
      method: "webservice.connection:modifyPassword",
      params: {
        login: login,
        password:password,
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }

  getEtatClient(login:string, id:any): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc: "2.0",
      method: "webservice.connection:getEtatClient",
      params: {
        login: login,
        id:id
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }

  confirmEmail(email:string, token:string): Observable<any> {
    let testData:FormData = new FormData();
    testData.append('email', email);
    testData.append('token', token);
    return this.http.post(environment.webservice+"validemail", testData);
  }
  getDossierServices(idDossier){
    let rpcMethod = new JSONRpc({
      jsonrpc: "2.0",
      method: "webservice.dossier:getDossierServices",
      params: {
        idDossier:idDossier,
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }
  // updateServiceOld(idDossier,service,mode,action){

  //   let rpcMethod = new JSONRpc({
  //     jsonrpc: "2.0",
  //     method: "webservice.dossier:updateServiceOld",
  //     params: {
  //       idDossier:idDossier,
  //       service: service,
  //       mode:mode,
  //       action:action
  //     }
  //   });
  //   return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  // }
  updateService(idDossier,service,mode,action){

    let rpcMethod = new JSONRpc({
      jsonrpc: "2.0",
      method: "webservice.dossier:updateService",
      params: {
        idDossier:idDossier,
        service: service,
        mode:mode,
        action:action
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }

  getDataBSRef(idDossier, urlBS){

    let rpcMethod = new JSONRpc({
      jsonrpc: "2.0",
      method: "webservice.dossier:getDataBSRef",
      params: {
        idDossier:idDossier,
        urlBS: urlBS
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }
  setEtatUser(idUser, loginUser, etat){
    let rpcMethod = new JSONRpc({
      jsonrpc: "2.0",
      method: "webservice.connection:setEtatUser",
      params: {
        idUser:idUser,
        loginUser: loginUser,
        etat:etat
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }

  calculanciennete(params){
    let rpcMethod = new JSONRpc({
      jsonrpc: "2.0",
      method: "webservice.cobham:calculanciennete",
      params: {
        params:params
      }
    });
    return this.callPOSTJSONRpc(environment.BOCC_URL, rpcMethod);
  }

  setDossierComplete(iddossier, etatComplete){
    let rpcMethod = new JSONRpc({
      jsonrpc: "2.0",
      method: "webservice.dossier:setDossierComplete",
      params: {
        iddossier:iddossier,
        etatComplete: etatComplete
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }
  
  getRules(calcul){
    let rpcMethod = new JSONRpc({
      jsonrpc: "2.0",
      method: "webservice.cobham:getRules",
      params: {
        calcul:calcul
      }
    });
    return this.callPOSTJSONRpc(environment.BOCC_URL, rpcMethod);
  }

  firstConnectionOdoo(login, id): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc : "2.0",
      method:"webservice.connection:firstConnectionOdoo",
      params: {
        email: login,
        id: id
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }

    contactSupport(form): Observable<any> {
        let testData:FormData = new FormData();
        testData.append('objet', form.objet);
        testData.append('nom', form.nom);
        testData.append('prenom', form.prenom);
        testData.append('email', form.email);
        testData.append('demande', form.demande);
        return this.http.post(environment.webservice+"contactSupport", testData);
    }

  getDatePeriode(dateentree, enposte, datesortie, motif, daterupture, licmaladie, datemaladie): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc : "2.0",
      method: "webservice.dossier:getDatePeriode",
      params: {
        dateentree: dateentree,
        enposte: enposte,
        datesortie: datesortie,
        motif: motif,
        daterupture: daterupture,
        licmaladie: licmaladie,
        datemaladie: datemaladie,
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }
  getLibelleTooltip(): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc : "2.0",
      method: "webservice.dossier:getLibelleTooltip",
      params: {}
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }

  getSizeFileMax(): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc : "2.0",
      method: "webservice.bulletin:getSizeFileMax",
      params: {}
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }

  getConstantes(arrayCodeDate): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc : "2.0",
      method: "webservice.dossier:getConstantes",
      params: {
        codeDate: arrayCodeDate
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }
  sendMailErrorAdmin(iddossier): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc : "2.0",
      method: "webservice.dossier:sendMailErrorAdmin",
      params: {
        iddossier:iddossier
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }

  getJSONEnteteDossierByCalculette(iddossier, nameCalculette): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc : "2.0",
      method: "webservice.dossier:getJSONEnteteDossierByCalculette",
      params: {
        iddossier:iddossier,
        nameCalculette:nameCalculette
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }

  getJSONLignesBSDossierByCalculette(iddossier, nameCalculette): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc : "2.0",
      method: "webservice.dossier:getJSONLignesBSDossierByCalculette",
      params: {
        iddossier:iddossier,
        nameCalculette:nameCalculette
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }
  
  getCCparam(iddossier, idcc_cc, secteur, bool_adh_synd_sign, cp_emp_temp): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc : "2.0",
      method: "webservice.dossier:getCCparamIdccIncluded",
      params: {
        iddossier:iddossier,
        idcc_cc:idcc_cc,
        secteur:secteur,
        bool_adh_synd_sign:bool_adh_synd_sign,
        cp_emp_temp,
        token_calc: environment.tokencalc
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }
  
  getParamsByCode(code): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc : "2.0",
      method: "webservice.bobs:getParamsByCode",
      params: {
        code : code,
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }

  // getPrincipeCalcul(id): Observable<any> {
  //   let rpcMethod = new JSONRpc({
  //     jsonrpc : "2.0",
  //     method: "webservice.bocc:getPrincipeCalcul",
  //     params: {
  //       id : id,
  //     }
  //   });
  //   return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  // }

  getParameterPossibleValues(codes): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc : "2.0",
      method: "webservice.bobs:getParameterPossibleValues",
      params: {
        codes : codes,
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }

    verifySiren(siren: any) {
        let rpcMethod = new JSONRpc({
            jsonrpc : "2.0",
            method: "webservice.bobs:verifySiren",
            params: {
                siren : siren,
            }
        });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
}
    getDataFromSiret(siret: any) {
        let rpcMethod = new JSONRpc({
            jsonrpc : "2.0",
            method: "webservice.bobs:getDataFromSiret",
            params: {
                siret : siret,
            }
        });
        return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
    }

    getCCNames(ccNums: Array<number>) {
        let rpcMethod = new JSONRpc({
            jsonrpc : "2.0",
            method: "webservice.dossier:getCCNames",
            params: {
                ccNums : ccNums,
            }
        });
        return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
    }

    setBibleSnippet(dossier, rapport:string, fragments: Array<string>) {
        let rpcMethod = new JSONRpc({
            jsonrpc : "2.0",
            method: "webservice.dossier:setBibleSnippet",
            params: {
              dossier : dossier,
              rapport: rapport,
              fragments: fragments
            }
        });
        return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
    }

    getMissingBsFromPeriod(dossierId, startDate, endDate) {
        let rpcMethod = new JSONRpc({
            jsonrpc : "2.0",
            method: "webservice.dossier:getMissingBsFromPeriod",
            params: {
                dossierId: dossierId,
                startDate: startDate,
                endDate: endDate,
            }
        });
        return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
    }

    processRecoResponse(dossierId, response) {
        let rpcMethod = new JSONRpc({
            jsonrpc : "2.0",
            method: "webservice.bulletin:processRecoResponse",
            params: {
                dossierId: dossierId,
                response: response,
            }
        });
        return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
    }

    logIfDossierHasDoublon(dossierId, page) {
        let rpcMethod = new JSONRpc({
            jsonrpc : "2.0",
            method: "webservice.dossier:logIfDossierHasDoublon",
            params: {
                dossierId: dossierId,
                page: page
            }
        });
        return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
    }

    getEnteteValueFromDossier(idDossier, codeParametre) {
      let rpcMethod = new JSONRpc({
          jsonrpc : "2.0",
          method: "webservice.dossier:getEnteteValueFromDossier",
          params: {
            idDossier: idDossier,
            codeParametre: codeParametre
          }
      });
      return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
    }

    resetAllRisquesData(idDossier) {
      let rpcMethod = new JSONRpc({
          jsonrpc : "2.0",
          method: "webservice.dossier:resetAllRisquesData",
          params: {
            idDossier: idDossier
          }
      });
      return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
    }

  getDossierFromDelegationToken(token) {
    let rpcMethod = new JSONRpc({
        jsonrpc : "2.0",
        method: "webservice.dossier:getDossierFromDelegationToken",
        params: {
          token: token
        }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }
    
  createDossierDelegation(couponId = null): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc : "2.0",
      method:"webservice.dossier:createDossierDelegation",
      params: {
        couponId: couponId
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }

  uploadContractDocument(file: File, dossierId: string): Observable<any> {
    let data:FormData = new FormData();
    data.append('file_upload', file, file.name);
    data.append('dossierId', dossierId);
    return this.http.post(environment.webservice+"uploadDocument", data);
  }

  updateContractsType(dossierId: any, types): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc: "2.0",
      method: "webservice.dossier:updateContractsType",
      params: {
        dossierId: dossierId,
        types: types,
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }

  updateStepDelegation(dossierId: any, step: number): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc: "2.0",
      method: "webservice.dossier:updateStepDelegation",
      params: {
        dossierId: dossierId,
        step: step,
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }

  getDelegationTokenFromDossier(dossierId: any): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc: "2.0",
      method: "webservice.dossier:getDelegationTokenFromDossier",
      params: {
        dossierId: dossierId
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }
  
  getDisplayedCalculette(iddossier, action, codeCalculette): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc : "2.0",
      method: "webservice.dossier:getDisplayedCalculette",
      params: {
        token_calc: environment.tokencalc,
        iddossier:iddossier,
        action:action,
        codeCalculette:codeCalculette
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }
  isAREApplicable(iddossier): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc : "2.0",
      method: "webservice.dossier:isAREApplicable",
      params: {
        iddossier:iddossier
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }
  getRapportApplicable(iddossier): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc : "2.0",
      method: "webservice.dossier:getRapportApplicable",
      params: {
        iddossier:iddossier
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }
  salRefDetailDelete(data): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc: "2.0",
      method: "webservice.dossier:salRefDetailDelete",
      params: {
        data: data,
        token_calc: environment.tokencalc
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }
  salRefDetailSave(data): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc: "2.0",
      method: "webservice.dossier:salRefDetailSave",
      params: {
        data: data,
        token_calc: environment.tokencalc
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }
  updateSalRefCalc(iddossier): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc: "2.0",
      method: "webservice.dossier:updateSalRefCalc",
      params: {
        iddossier: iddossier,
        token_calc: environment.tokencalc
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }
  changeSalRefApproche(iddossier, value): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc: "2.0",
      method: "webservice.dossier:changeSalRefApproche",
      params: {
        iddossier: iddossier,
        value: value,
        token_calc: environment.tokencalc
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }
  filter_calculettes_condition(iddossier): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc: "2.0",
      method: "webservice.dossier:filter_calculettes_condition",
      params: {
        iddossier: iddossier,
        token_calc: environment.tokencalc
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }
  getIdccListe(){
    let rpcMethod = new JSONRpc({
      jsonrpc: "2.0",
      method: "webservice.bocc:getIdccListe",
      params: {
        token_calc: environment.tokencalc
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }

  validationCobhamMail(email, iddossier): Observable<any> {
    const data:FormData = new FormData();
    data.append('email', email);
    data.append('iddossier', iddossier);
    return this.http.post(environment.webservice+"validcobham", data);
  }

  getLastBsEntete(iddossier){
    let rpcMethod = new JSONRpc({
      jsonrpc: "2.0",
      method: "webservice.dossier:getLastBsEntete",
      params: {
        token_calc: environment.tokencalc,
        iddossier: iddossier
      }
    });
    return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
  }
}